'use client';

import {
  type TalentUserFragmentFragment,
  useTalentMicrofrontendTalentAuthContextGetUserDataQueryQuery,
} from './graphql/get-user-data.v5.generated';

export type TTalentUser = TalentUserFragmentFragment & {
  user_parent_id?: number | null;
};

// These props are only used for testing or storybook envs
type TOptions =
  | {
      skip: false;
      variables?: {
        companyId?: number;
        userId?: number;
        employeeId?: number;
        userParentId?: number;
      };
    }
  | {
      skip: true;
    };

export const useGetUserData = (options: TOptions) => {
  const authResponse =
    useTalentMicrofrontendTalentAuthContextGetUserDataQueryQuery({
      variables: options.skip
        ? undefined
        : {
            input: {
              employee_id: options.variables?.employeeId,
              user_id: options.variables?.userId,
              company_id: options.variables?.companyId,
              user_parent_id: options.variables?.userParentId,
            },
          },
      skip: options.skip,
      context: { clientName: 'v5' },
      notifyOnNetworkStatusChange: true,
    });

  if (options.skip || authResponse.loading) {
    return {
      ...authResponse,
      user: null,
      loading: true,
    };
  }

  if (authResponse.error) {
    return {
      ...authResponse,
      user: null,
      queryParamsIds: null,
    };
  }

  if (!authResponse.data?.talent.talent_get_user_profile) {
    return {
      ...authResponse,
      user: null,
      queryParamsIds: null,
      error: new Error(
        `No user found with the following data: ${JSON.stringify({
          employee_id: options.variables?.employeeId || null,
          user_id:
            options.variables?.userId || options.variables?.employeeId || null,
          company_id: options.variables?.companyId || null,
          user_parent_id: options.variables?.userParentId,
        })}`,
      ),
    };
  }

  const user: TTalentUser = {
    ...authResponse.data.talent.talent_get_user_profile,
    user_parent_id: options.variables?.userParentId,
  };
  return {
    ...authResponse,
    user,
    loading: false,
  };
};
